import { Link } from "react-router-dom";
import { Landmark, Train, Shield, Car, UtensilsCrossed, Package, Pill, FlaskConical, Building2, Wheat, Factory, ArrowUpRight } from "lucide-react";

const INDUSTRIES = [
  { icon: Landmark, name: "Government", body: "Empanelled vendor for PSU procurement across multiple states." },
  { icon: Train, name: "Railways", body: "Bogie assembly and rolling-stock components manufacturing." },
  { icon: Shield, name: "Defense", body: "Critical machining and welding stations for defense platforms." },
  { icon: Car, name: "Automobile", body: "Robotic welding cells and press-shop automation." },
  { icon: UtensilsCrossed, name: "Food Processing", body: "Hygienic conveyors, mixers and packaging lines." },
  { icon: Package, name: "Packaging", body: "High-speed flow-wrappers, cartoners and case-packers." },
  { icon: Pill, name: "Pharmaceutical", body: "GMP-compliant reactors, granulators and blister lines." },
  { icon: FlaskConical, name: "Chemical", body: "Jacketed reactors, dryers and CIP-ready process systems." },
  { icon: Building2, name: "Construction", body: "Rebar bending, batching automation and material handling." },
  { icon: Wheat, name: "Agriculture", body: "Grain-handling, seed-treatment and bagging automation." },
  { icon: Factory, name: "Manufacturing", body: "Turn-key automation cells for discrete & process industries." },
];

export default function Industries() {
  return (
    <>
      <section className="bg-brand-navy text-white">
        <div className="section-x mx-auto max-w-[1440px] py-24">
          <div className="overline text-accent">Industries served</div>
          <h1 className="mt-3 font-display text-5xl md:text-6xl font-black tracking-tight leading-[1.02] max-w-3xl">Eleven industries. One engineering standard.</h1>
          <p className="mt-5 max-w-2xl text-slate-300 text-lg leading-relaxed">
            From aerospace-grade CNC machines for defense to hygienic packaging lines for pharma — every ShivShakti build is engineered to the same durability benchmark.
          </p>
        </div>
      </section>

      <section className="section-x mx-auto max-w-[1440px] py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {INDUSTRIES.map((i, idx) => (
          <div key={idx} className="group relative rounded-xl border border-slate-200 bg-white p-7 hover:-translate-y-1 hover:shadow-[0_20px_50px_-25px_rgba(10,37,64,0.25)] transition-[transform,box-shadow] duration-300">
            <span className="corner-mark tl"/>
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-brand-navy text-white group-hover:bg-accent transition-colors duration-200">
              <i.icon className="h-5 w-5"/>
            </span>
            <h3 className="mt-5 font-display text-lg font-bold text-brand-navy tracking-tight">{i.name}</h3>
            <p className="mt-2 text-sm text-slate-500 leading-relaxed">{i.body}</p>
            <Link to="/products" className="mt-5 inline-flex items-center gap-1 text-xs font-semibold text-accent">See machines <ArrowUpRight className="h-3.5 w-3.5"/></Link>
          </div>
        ))}
      </section>
    </>
  );
}
